export default __webpack_public_path__ + "static/media/DINPro-Regular.5f319438.ttf";